<template>
  <section class="switch-percent-or-number">
    <div class="switch-percent-or-number__switch">
      <BField>
        <span class="switch-percent-or-number__switch__option flag-option">
          <span class="switch-percent-or-number__switch__option__pc">Número de eventos</span>
          <span class="switch-percent-or-number__switch__option__movil">N. Eventos</span>
        </span>
        <BSwitch inset size="is-small" color="secondary" v-model="isSwitchedSection"></BSwitch>
        <span class="switch-percent-or-number__switch__option flag-option-2">
          <span class="switch-percent-or-number__switch__option__pc">Tiempo de Evento</span>
          <span class="switch-percent-or-number__switch__option__movil">T. Evento</span>
        </span>
      </BField>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SwitchPercentOrNumberComparativePreviousTournaments',
  components: {},
  computed: {},
  data() {
    return { isSwitchedSection: true, tab: 1 };
  },
  watch: {
    isSwitchedSection() {
      if (this.isSwitchedSection) {
        this.tab = 0;
      } else {
        this.tab = 1;
      }
      this.$emit('onChangeSwitch', this.tab);
    },
  },
  methods: {},
  created() {},
};
</script>
<style lang="scss">
.switch-percent-or-number {
  .switch {
    margin-top: -3px !important;
    margin-left: 10px;
  }
  .switch input[type='checkbox'] + .check.is-success-passive,
  .switch input[type='checkbox'] + .check:hover {
    background: #cbee6b !important;
  }
  .switch input[type='checkbox'] + .check.is-success-passive,
  .switch input[type='checkbox'] + .check:hover,
  .switch input[type='checkbox']:checked + .check:hover {
    background: #cbee6b !important;
    box-shadow: none !important;
  }
  .switch input[type='checkbox'] + .check {
    background: #cbee6b !important;
    box-shadow: none !important;
  }
}
</style>
<style lang="scss" scoped>
.switch-percent-or-number {
  width: 55%;
  height: 28px;
  border-radius: 5px;
  margin-left: 1.6%;
  border: solid 1px #cfd3dc;
  @media screen and (max-width: 1320px) {
    width: 75%;
  }
  @media screen and (max-width: 680px) {
    width: 90%;
    margin-left: 5%;
    margin-bottom: 10px;
  }
  &__switch {
    height: 28px;
    margin: 0 auto;
    display: inline-flex;
    justify-content: center;
    &__option {
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.15;
      letter-spacing: -0.26px;
      font-size: 13px;
      text-align: center;
      color: #132839;
      font-family: 'Avenir-Demi';
      line-height: 28px;
      width: 120px;
      text-align: center;
      @media screen and (max-width: 350px) {
        width: 90px;
      }
      &__pc {
        @media screen and (max-width: 350px) {
          display: none;
        }
      }
      &__movil {
        display: none;
        @media screen and (max-width: 350px) {
          display: inline-block;
        }
      }
    }
  }
}
</style>
